export const list = {
  table: {
    exchange: 'Exchange',
  },
  pageHeader: {
    title: 'Notification list',
  },
}
